<template>
  <router-link
    :to="{ name: 'export' }"
    class="btns btns--font-medium highlights__btn-box highlights__export"
  >
    <span class="highlights__icon iconfont iexport" alt="Export Button"></span>
    <span class="highlights__button-label">Export highlights</span>
  </router-link>
</template>
